"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IApikeyToken = exports.IApikeyFrozen = exports.IApikeyInactive = exports.IApikeyPublic = void 0;
var IApikeyPublic;
(function (IApikeyPublic) {
    IApikeyPublic[IApikeyPublic["THE_KEY_CAN_ALSO_ACCESS_PRIVATE_RESOURCES_0"] = 0] = "THE_KEY_CAN_ALSO_ACCESS_PRIVATE_RESOURCES_0";
    IApikeyPublic[IApikeyPublic["THE_KEY_CAN_ONLY_ACCESS_PUBLIC_RESOURCES_1"] = 1] = "THE_KEY_CAN_ONLY_ACCESS_PUBLIC_RESOURCES_1";
})(IApikeyPublic = exports.IApikeyPublic || (exports.IApikeyPublic = {}));
var IApikeyInactive;
(function (IApikeyInactive) {
    IApikeyInactive[IApikeyInactive["ACTIVE_0"] = 0] = "ACTIVE_0";
    IApikeyInactive[IApikeyInactive["INACTIVE_1"] = 1] = "INACTIVE_1";
})(IApikeyInactive = exports.IApikeyInactive || (exports.IApikeyInactive = {}));
var IApikeyFrozen;
(function (IApikeyFrozen) {
    IApikeyFrozen[IApikeyFrozen["NOT_FROZEN_0"] = 0] = "NOT_FROZEN_0";
    IApikeyFrozen[IApikeyFrozen["FROZEN_1"] = 1] = "FROZEN_1";
})(IApikeyFrozen = exports.IApikeyFrozen || (exports.IApikeyFrozen = {}));
var IApikeyToken;
(function (IApikeyToken) {
    IApikeyToken[IApikeyToken["THE_AUTHTOKEN_MECHANISM_IS_DESABLED_0"] = 0] = "THE_AUTHTOKEN_MECHANISM_IS_DESABLED_0";
    IApikeyToken[IApikeyToken["THE_AUTHTOKEN_MECHANISM_IS_REQUIRED_FOR_POSTCREATE_AND_DELETE_REQUEST_1"] = 1] = "THE_AUTHTOKEN_MECHANISM_IS_REQUIRED_FOR_POSTCREATE_AND_DELETE_REQUEST_1";
})(IApikeyToken = exports.IApikeyToken || (exports.IApikeyToken = {}));
